// A customer's video Brandwall already keeps (D-090): nothing is lost while the brand waits for
// the creator's yes. Shown until the post has permission.
import { LIVE_PERMISSIONS, type Permission } from "@brandwall/contracts";

export function SavedVideo({
  post,
}: {
  post: { mediaType: string; videoSaved?: boolean; permission: Permission };
}) {
  if (post.mediaType !== "video" || !post.videoSaved) return null;
  if (LIVE_PERMISSIONS.includes(post.permission)) return null;
  return (
    <div className="small saved-video" title="Brandwall keeps a private copy of this video">
      ✓ Saved and ready. Goes up in full when they say yes.
    </div>
  );
}
